import { createFileRoute } from "@tanstack/react-router"
import DesignSystemTrace from "~/pages/design-system/components/Trace"

export const Route = createFileRoute("/_auth/internal/design-system/components/trace")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemTrace />
}
